<template>
  <div id="container">

    <div v-if="showGrGsData" class="  flex w-full   p-5">
      <div class="vx-col flex items-center justify-center flex-col  mx-auto text-center">
        <vs-button @click="$emit('close')" size="large">Back</vs-button>
        <h1>{{ showTitle }}</h1>
        <div v-if="data.length > 0" class="red-border">
          <span class="text-danger"><strong>{{ data.length }} </strong></span>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full   mb-base">
            <vx-card class="p-2 mb-5" v-for="(val, index) in data">
              <div class="text-center pb-5">
                <h4>{{ val.master }}</h4>
                <small class="text-grey">Master Stock Code</small>
              </div>
              <h5>ITEM {{ val.itemNumber }}</h5>
              <div class="flex justify-between text-center">
                <span>
                  <p class="text-xl font-semibold">{{ val.number }}</p>

                  <small v-if="subject == 'gr'">GR NUMBER</small>
                  <small v-if="subject == 'gs'">GS NUMBER</small>
                </span>

                <span>
                  <p class="text-xl font-semibold">{{ val.sub }}</p>
                  <small class="text-grey">Sub Stock Code</small>
                </span>
              </div>
              <div class="text-center pt-5">
                <h4>{{ val.docNumber }}</h4>
                <small class="text-grey">Document No.</small>
              </div>
              <vs-button @click="processMovementData(val.id)" type="gradient" class="w-full mt-6"
                color="primary">PROCESS</vs-button>
            </vx-card>
          </div>
        </div>
      </div>

    </div>
    <div v-else>
      <processMovement @refreshData="getData(); showGrGsData = true" @close="showGrGsData = true" :id="selectedId"
        :subject="subject">
      </processMovement>

    </div>


  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '@/mixin/axiosMixin';
import processMovement from './processMovement.vue';
import { alertMixin } from '@/mixin/alertMixin';
export default {
  mixins: [axiosMixin, alertMixin],
  components: {
    StatisticsCardLine,
    processMovement
  },
  data() {
    return {
      data: [],
      showGrGsData: true,
      selectedId: ""
    };
  },
  props: {
    subject: {
      type: String,
      default: false,

    }
  },
  computed: {
    showTitle() {
      return this.subject == 'gr' ? 'Goods Received' : 'Goods Sent Out';
    }
  },
  methods: {
    checkIfLocationIsValid(id) {
      this.startLoading();
      this.aronPost('getRecordDetails', { subject: this.subject, id: id }, '', '')
        .then(response => {
          if (response.status) {
            this.showGrGsData = false;
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          this.decodeErrorFromAxios(error)
          this.stopLoading();
        })

    },

    processMovementData(id) {
      this.selectedId = id;
      this.checkIfLocationIsValid(id)
      //   this.showGrGsData = false;
    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.startLoading();
      this.aronPost('getWarehouseData', { subject: this.subject }, '', '')
        .then(response => {
          if (response.status) {
            this.data = response.data.data;
          } else {

            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })

    }

  },
  mounted() {
    this.getData();
  },
  created() {

  }
};
</script>
